// extracted by mini-css-extract-plugin
export var certificateListItem = "AptitudeItem-module--certificateListItem--1qZwE";
export var imageWrap = "AptitudeItem-module--imageWrap--317w7";
export var contentWrap = "AptitudeItem-module--contentWrap--2OcPe";
export var title = "AptitudeItem-module--title--3nupQ";
export var scoreWrapper = "AptitudeItem-module--scoreWrapper--1tHTl";
export var score = "AptitudeItem-module--score--3kAOe";
export var grade = "AptitudeItem-module--grade--289xK";
export var moduleProgressBar = "AptitudeItem-module--moduleProgressBar--di_IP";
export var progress = "AptitudeItem-module--progress--XOAjc";